// covered-by: frontends/carrie/src/ask-v2/transport/__tests__/AskV2ChatFileDrop.test.tsx
import {
  createContext,
  useContext,
  useEffect,
  type MutableRefObject,
} from "react";

export type ChatFileDropAddFiles = (files: File[]) => void;

export const ChatFileDropTargetContext =
  createContext<MutableRefObject<ChatFileDropAddFiles | null> | null>(null);

/**
 * Composer registration for files dropped on the surrounding AskV2ChatFileDrop.
 * No-ops when the composer renders outside that zone.
 */
export function useRegisterChatFileDropTarget(
  addFiles: ChatFileDropAddFiles,
  enabled: boolean,
) {
  const targetRef = useContext(ChatFileDropTargetContext);
  useEffect(() => {
    if (!targetRef) return;
    targetRef.current = enabled ? addFiles : null;
    return () => {
      if (targetRef.current === addFiles) {
        targetRef.current = null;
      }
    };
  }, [addFiles, enabled, targetRef]);
}
